/**
 * 账本的接口。一个 routeId,与 `apps/visual-game-server/src/routes/llm-admin/ledger.js`
 * 的 `@callchain.routeId` 标注逐字对应。
 *
 * **账本是调用日志的另一半。** 桥就一条:`billing_ledger.ref_type = 'llm_chat' AND ref_id = request_id`。
 * `ref_type` 不是 `llm_chat` 的行(充值、赠送、别的业务扣款)也一起列 —— 只给 LLM 那几行解释不了余额。
 *
 * `amount` 是有符号的：扣款为负、充值为正。`call` 只在这一行扣的是 LLM 调用时才有值；
 * ref 指向的调用行被分区维护清掉了也是 null。字段与服务端 snake_case 响应同名透传。
 */

import { llmHttp } from './http.js'

/**
 * 一个用户的流水,新的在前。`user_id` 必填 —— 账本按 `(user_id, created_at)` 索引读,不给用户就是全表扫。
 *
 * @callchain.routeId llm.admin.ledger.list
 * @param {{ user_id: string, limit: number, cursor: string|null }} query
 * @returns {Promise<object>}
 */
export function listUserLedger(query) {
  return llmHttp().get('/ledger', { query, routeId: 'llm.admin.ledger.list' })
}
